import { useT } from "@/lib/i18n";
import { COMPANY } from "@/lib/legal";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function ImprintPage() {
  const { t } = useT();
  return (
    <LegalLayout title={t("legal.imprint.title")}>
      <Section title={t("legal.imprint.responsible")}>
        <p className="font-medium text-slate-100">{COMPANY.name}</p>
        <p>{COMPANY.street}</p>
        <p>
          {COMPANY.postalCode} {COMPANY.city}
        </p>
        <p>{COMPANY.country}</p>
      </Section>

      <Section title={t("legal.imprint.contact")}>
        <p>
          E-Mail:{" "}
          <a
            href={`mailto:${COMPANY.email}`}
            className="text-[#D4AF37] hover:underline"
          >
            {COMPANY.email}
          </a>
        </p>
        {COMPANY.website && (
          <p>
            Web:{" "}
            <a
              href={COMPANY.website}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#D4AF37] hover:underline"
            >
              {COMPANY.website}
            </a>
          </p>
        )}
      </Section>

      {(COMPANY.responsiblePerson ||
        COMPANY.registerCourt ||
        COMPANY.vatId) && (
        <Section title={t("legal.imprint.legal")}>
          {COMPANY.responsiblePerson && (
            <p>
              {t("legal.imprint.responsiblePerson")}:{" "}
              {COMPANY.responsiblePerson}
            </p>
          )}
          {COMPANY.registerCourt && (
            <p>
              {t("legal.imprint.register")}: {COMPANY.registerCourt}
              {COMPANY.registerNumber ? `, ${COMPANY.registerNumber}` : ""}
            </p>
          )}
          {COMPANY.vatId && (
            <p>
              {t("legal.imprint.vat")}: {COMPANY.vatId}
            </p>
          )}
        </Section>
      )}

      <Section title={t("legal.imprint.disclaimerTitle")}>
        <p className="text-slate-400">{t("legal.imprint.disclaimerBody")}</p>
      </Section>
    </LegalLayout>
  );
}

export function LegalLayout({ title, children }) {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="mx-auto max-w-3xl px-4 sm:px-8 py-10 sm:py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-[#D4AF37] mb-6 transition-colors"
          data-testid="legal-back-link"
        >
          <ArrowLeft className="h-4 w-4" />
          {t("legal.back")}
        </Link>
        <h1 className="font-serif-display text-3xl sm:text-4xl text-white tracking-tight mb-8">
          {title}
        </h1>
        <div className="space-y-8 text-sm text-slate-300 leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-serif-display text-lg text-white mb-2 tracking-tight">
        {title}
      </h2>
      <div className="space-y-1.5 text-slate-300">{children}</div>
    </section>
  );
}
